import { createSelector } from "@reduxjs/toolkit";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { normalizeMod } from "@src/store/slices/experienceBuilder/common/utils/normalizeMod";
import { fromMods } from "@src/store/slices/experienceBuilder/common/utils/fromMods";

export const getConvertedMods = createSelector(
  experienceBuilderSlice.selectors.getMods,
  (mods) => fromMods(mods.map(normalizeMod))
);
